import { IOfficialDailyResponse } from "../../../model/base/response/official-daily-response";
import { Pagination } from "../../../model/paginatiion";


export type OfficialDailyState = {
  officialDaily: Pagination<IOfficialDailyResponse>;
};

export enum ACTION_TYPES {
  loadingData = 'loadingData',
  clearData = 'clearData'
}

export const OfficialDailyReducer = (state: OfficialDailyState, action: any): OfficialDailyState => {
  const { type, payload } = action;
  switch (type) {
    case ACTION_TYPES.loadingData:
      return {
        ...state,
        officialDaily: payload,
      };
    case ACTION_TYPES.clearData:
      return {
        ...state,
        officialDaily: {} as Pagination<IOfficialDailyResponse>,
      };
    default:
      throw new Error(`Unhandled action type: ${type}`);
  }
}